import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {BrandState} from "./BrandState";
import {BRAND_CREATED, BRAND_UPDATED, BRANDS_FETCHED} from "../../action/brand/actionType";

const initState: BrandState = {
	brands: none,
};

const reducer = handleActions({
	[BRANDS_FETCHED]: (state: BrandState, action: Action<any>): BrandState => {
		return {...state, brands: option(action.payload.brands)}
	},
	[BRAND_CREATED]: (state: BrandState, action: Action<BRAND_CREATED>): BrandState => {
		return {...state, brands: option(state.brands.getOrElse([]).concat(action.payload.brand))}
	},
	[BRAND_UPDATED]: (state: BrandState, action: Action<BRAND_UPDATED>): BrandState => {
		const brands = state.brands.getOrElse([]).map(b => b.id == action.payload.brand.id ? action.payload.brand : b);
		return {...state, brands: option(brands)}
	}
}, initState);

export default reducer;